import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  ADD_UPDATE_JURY_BRIEFING_ACTION_TYPE, addUpdateJuryBriefingUrl,
  award_event_id,
  GET_ADMIN_APPLICATION_LIST_ACTION_TYPE, GET_ADMIN_APPLICATION_MATRIX_LIST_ACTION_TYPE,
  GET_ADMIN_DASHBOARD_LIST_ACTION_TYPE, GET_ADMIN_JURY_BRIEFING_LIST_ACTION_TYPE, GET_APPLICATION_QUERY_LIST_ACTION_TYPE, getAdminApplicationListUrl, getAdminApplicationMatrixListUrl, getAdminDashboardListUrl, getAdminJuryBriefingListUrl,
  getApplicationQueryListUrl,
  headers,
  jury_id,
  user_id,
  VERIFY_APPLICATION_ACTION_TYPE,
  verifyApplicationFormUrl, insertUpdateApplicationFormSuvinScoringUrl, INSERT_UPDATE_APPLICATION_FORM_SUVIN_SCORING_ACTION_TYPE
} from "../../utils/constants";



export const get_admin_application_list_action =
  (round_id, award_event_profile_id, application_status_id, application_no) => async (dispatch) => {
    try {
      const mapdata = {
        user_id: sessionStorage.getItem('user_id'),
        award_event_id: sessionStorage.getItem('award_event_id'),
        round_id: round_id,
        award_event_profile_id: award_event_profile_id,
        application_status_id: application_status_id,
        application_no: application_no
      };
      const params = {
        user_id: mapdata.user_id === "" ? null : mapdata.user_id,
        award_event_id: mapdata.award_event_id === "" ? null : mapdata.award_event_id,
        round_id: mapdata.round_id === "" ? null : mapdata.round_id,
        award_event_profile_id: mapdata.award_event_profile_id === "" ? null : mapdata.award_event_profile_id,
        application_status_id: mapdata.application_status_id === "" ? null : mapdata.application_status_id,
        application_no: mapdata.application_no === "" ? null : mapdata.application_no,
        
      };
      const res = await axiosGet(getAdminApplicationListUrl, params, headers);
      dispatch({
        type: GET_ADMIN_APPLICATION_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const verify_application_action =
  (application_form_id, application_status_id, rejectRemark) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id: sessionStorage.getItem('user_id'),
          application_form_id: application_form_id != null ? application_form_id : null,
          application_status_id: application_status_id,
          rejectRemark: rejectRemark ? rejectRemark : null
        };
        
        const res = await axiosPost(verifyApplicationFormUrl, mapdata, headers);
        dispatch({
          type: VERIFY_APPLICATION_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const get_admin_applicationMatrix_list_action =
  (Name, Email, Phone, Experience) => async (dispatch) => {
    try {
      const mapdata = {
        user_id: sessionStorage.getItem('user_id'),
        award_event_id: sessionStorage.getItem('award_event_id'),
        Name: Name,
        Email: Email,
        Phone: Phone,
        Experience: Experience,
      };
      const params = {
        user_id: mapdata.user_id === "" ? null : mapdata.user_id,
        Name: mapdata.Name === "" ? null : mapdata.Name,
        Email: mapdata.Email === "" ? null : mapdata.Email,
        Phone: mapdata.Phone === "" ? null : mapdata.Phone,
        Experience: mapdata.Experience === "" ? null : mapdata.Experience,
      };
      const res = await axiosGet(getAdminApplicationMatrixListUrl, params, headers);
      dispatch({
        type: GET_ADMIN_APPLICATION_MATRIX_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const get_admin_juryBriefing_list_action =
  () => async (dispatch) => {
    try {
      const mapdata = {
        user_id: sessionStorage.getItem('user_id'),
        award_event_id: sessionStorage.getItem('award_event_id'),
      };
      const params = {
        user_id: mapdata.user_id === "" ? null : mapdata.user_id,
        award_event_id: mapdata.award_event_id === "" ? null : mapdata.award_event_id,
      };
      const res = await axiosGet(getAdminJuryBriefingListUrl, params, headers);
      dispatch({
        type: GET_ADMIN_JURY_BRIEFING_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const juryBriefing_insertUpdate_action =
  (jury_id, award_event_jury_briefing_id, jury_briefing_by, jury_briefing_date) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id: sessionStorage.getItem('user_id'),
          award_event_jury_briefing_id: award_event_jury_briefing_id != null ? award_event_jury_briefing_id : null,
          jury_id: jury_id,
          award_event_id: sessionStorage.getItem('award_event_id'),
          jury_briefing_by: jury_briefing_by,
          jury_briefing_date: jury_briefing_date
        };
        const res = await axiosPost(addUpdateJuryBriefingUrl, mapdata, headers);
        dispatch({
          type: ADD_UPDATE_JURY_BRIEFING_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };
export const get_application_query_list_action =
  (application_no) => async (dispatch) => {
    try {
      const mapdata = {
        user_id: sessionStorage.getItem('user_id'),
        award_event_id: sessionStorage.getItem('award_event_id'),
        application_no: application_no
      };
      const params = {
        user_id: mapdata.user_id === "" ? null : mapdata.user_id,
        award_event_id: mapdata.award_event_id === "" ? null : mapdata.award_event_id,
        application_no: mapdata.application_no === "" ? null : mapdata.application_no,
      };
      const res = await axiosGet(getApplicationQueryListUrl, params, headers);
      dispatch({
        type: GET_APPLICATION_QUERY_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const insertUpdateApplicationFormSuvinScoring_action =
  (application_form_suvin_scoring_data_id, award_event_id, award_event_profile_id, application_form_id, award_scoring_pattern_id, content) =>
    async (dispatch) => {
      try {
        const mapdata = {
          user_id: sessionStorage.getItem('user_id'),
          application_form_suvin_scoring_data_id: application_form_suvin_scoring_data_id != null ? application_form_suvin_scoring_data_id : null,
          award_event_id: sessionStorage.getItem('award_event_id'), award_event_profile_id: award_event_profile_id,
          application_form_id: application_form_id,
          award_scoring_pattern_id: award_scoring_pattern_id, content: content
        };
        
        const res = await axiosPost(insertUpdateApplicationFormSuvinScoringUrl, mapdata, headers);
        dispatch({
          type: INSERT_UPDATE_APPLICATION_FORM_SUVIN_SCORING_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };